import { Space, Tag, Tooltip } from "antd";
import { TimestampCell } from "../../common/TimestampCell";
import { CopyableText } from "../../common/CopyableText";
import { ChartIconButton } from "../ChartIconButton";
import {
  getReadoutIsLate,
  getReadoutStatus,
  getReadoutTimestamp,
  getSnapshotValue,
  splitMeterStatus,
  statusSortValue,
} from "../readoutFormat";

const renderValue = (value: number | null | undefined): string => {
  if (value == null) {
    return "N/A";
  }
  return value.toFixed(2);
};

export const electricityColumns = (concentratorID: string) => [
  {
    title: "Meter Name",
    dataIndex: "name",
    key: "name",
    width: 200,
    sorter: true,
    render: (name: string, record: any) => (
      <Space>
        <CopyableText text={name} />
        <ChartIconButton
          concentratorID={concentratorID}
          meterID={record.id}
        />
      </Space>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 88,
    sorter: (a: any, b: any) =>
      statusSortValue(getReadoutStatus(a), getReadoutIsLate(a)) -
      statusSortValue(getReadoutStatus(b), getReadoutIsLate(b)),
    render: (_: unknown, record: any) => {
      const parsed = splitMeterStatus(getReadoutStatus(record), getReadoutIsLate(record));
      const freshnessTag = (
        <Tag color={parsed.isLate ? "red" : "green"}>
          {parsed.isLate ? "LATE" : "OK"}
        </Tag>
      );
      if (parsed.vendor.length === 0) {
        return freshnessTag;
      }

      const vendorTag = (
        <Tooltip title={parsed.vendor.join(", ")}>
          <Tag color="gold">VENDOR</Tag>
        </Tooltip>
      );

      if (parsed.isLate) {
        return (
          <Space direction="vertical" size={2}>
            {freshnessTag}
            {vendorTag}
          </Space>
        );
      }
      return vendorTag;
    },
  },
  {
    title: "Active Energy [kWh]",
    dataIndex: "latest_active_value",
    key: "latest_active_value",
    width: 140,
    sorter: true,
    render: (_value: number | null, record: any) =>
      renderValue(getSnapshotValue(record, "active")),
  },
  {
    title: "Reactive [kVArh]",
    dataIndex: "latest_reactive_value",
    key: "latest_reactive_value",
    width: 140,
    sorter: true,
    render: (_value: number | null, record: any) =>
      renderValue(getSnapshotValue(record, "reactive")),
  },
  {
    title: "Timestamp",
    dataIndex: "latest_active_timestamp",
    key: "latest_active_timestamp",
    width: 160,
    sorter: true,
    render: (_value: string, record: any) => (
      <TimestampCell value={getReadoutTimestamp(record) ?? ""} />
    ),
  },
  {
    title: "UUID",
    dataIndex: "uuid",
    key: "uuid",
    width: 150,
    sorter: true,
    render: (value: string | null) => (
      <CopyableText text={value} display={value ? `${value.slice(0, 8)}...` : undefined} />
    ),
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    width: 160,
    sorter: true,
    render: (value: string | null) => value ?? "N/A",
  },
  {
    title: "Serial",
    dataIndex: "serial",
    key: "serial",
    width: 160,
    sorter: true,
    render: (value: string | null) => value ? value : "N/A",
  },
];
